import { createContext } from "react";

export interface Integration {
    badgeNeedsRefresh: boolean;
    refreshBadgeCount(): void;
    onBadgeFetched(): void;
}

export const IntegrationContext = createContext<Integration>({
    badgeNeedsRefresh: true,
    refreshBadgeCount() {},
    onBadgeFetched() {},
});
